import React from 'react';
import PropTypes from 'prop-types';

class CaptionFooter extends React.PureComponent {
  render() {
    return (
      <div className="footer">
        {this.props.children}
      </div>
    );
  }
}

CaptionFooter.propTypes = {
  children: PropTypes.any,
};

CaptionFooter.defaultProps = {
  children: '',
};

export default CaptionFooter;



// WEBPACK FOOTER //
// ./src/components/Caption/CaptionFooter.js